import React from 'react';
import { FormGroup, Label, Input } from 'reactstrap';

export const UsuarioForm = ({ fields, onChange }) => {

  const handleBannedChange = (e) => {
    const isChecked = e.target.checked;
    const syntheticEvent = {
      target: {
        name: 'banned',
        value: isChecked
      }
    };
    onChange(syntheticEvent);
  };

  const isBanned = fields.banned === true || fields.banned === 'true';

  return (
    <>
      <FormGroup>
        <Label for="username">Nombre de Usuario</Label>
        <Input type="text" id="username" value={fields.username || ''} disabled
          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }}
        />
      </FormGroup>
      
      <FormGroup>
        <Label for="email">Correo Electrónico</Label>
        <Input type="email" id="email" value={fields.email || ''} disabled
        style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }} />
      </FormGroup>

      <FormGroup>
        <Label for="role_id">Rol</Label>
        <Input type="text" id="role_id" value={fields.role_id === 2 ? 'Candidato' : 'Empresa'} disabled
          style={{ backgroundColor: '#f8f9fa', cursor: 'not-allowed' }} />
      </FormGroup>

      {/* --- SECCIÓN ESTADO (SWITCH TIPO APPLE) --- */}
      <FormGroup check className="mb-4 d-flex align-items-center" style={{ paddingLeft: 0 }}>
        <div style={{ position: 'relative', display: 'inline-block', width: '42px', height: '24px' }}>
          <Input
            type="checkbox"
            id="banned"
            name="banned"
            checked={isBanned}
            onChange={handleBannedChange}
            style={{
              appearance: 'none',
              WebkitAppearance: 'none',
              width: '42px',
              height: '24px',
              backgroundColor: isBanned ? '#000000' : '#545458',
              borderRadius: '20px',
              position: 'relative',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              border: 'none',
              margin: 0,
              backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3ccircle fill='white' cx='10' cy='10' r='9'/%3e%3c/svg%3e")`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: '20px',
              backgroundPosition: isBanned ? 'right 2px center' : 'left 2px center',
              outline: 'none',
              boxShadow: 'none'
            }}
          />
        </div>
        <Label 
          check 
          for="banned" 
          className="ms-3 mb-0" 
          style={{ 
            cursor: 'pointer', 
            fontWeight: '600', 
            userSelect: 'none',
            color: isBanned ? '#dc3545' : '#212529' 
          }}
        >
          {isBanned ? 'Baneado (Restringido)' : 'Activo'}
        </Label>
      </FormGroup>
      {/* ----------------------------------------- */}
      
      <FormGroup>
        <Label for="password">Nueva Contraseña</Label>
        <Input
          type="text"
          name="password"
          id="password"
          value={fields.password || ''}
          onChange={onChange}
          placeholder="Dejar en blanco para no cambiar"
          autoComplete="new-password"
        />
      </FormGroup>
      
      <FormGroup>
        <Label for="confirmPassword">Confirmar Nueva Contraseña</Label>
        <Input
          type="password"
          name="confirmPassword"
          id="confirmPassword"
          value={fields.confirmPassword || ''}
          onChange={onChange}
          placeholder="Confirmar nueva contraseña"
          autoComplete="new-password"
        />
      </FormGroup>
    </>
  );
};